import { createAsyncThunk } from '@reduxjs/toolkit'
import { Actions } from '@state/actions'
import {
  CreateInsiBatchCheckRequestDTO,
  InsiService,
  InsiVerificationBatchRequestDTO,
  UpdateInsiBatchCheckRequestResultDTO,
  InsiBatchResultRequest,
  InsiBatchResultResponseDTO,
} from '@services/InsiService'

const handleInsiError = (error: any, rejectWithValue: any) => {
  if (error?.response?.data?.message) {
    return rejectWithValue(error.response.data.message)
  }
  return rejectWithValue(error?.message ?? 'An unexpected error occurred')
}

export const createInsiBatchCheckRequest = createAsyncThunk<
  InsiVerificationBatchRequestDTO,
  CreateInsiBatchCheckRequestDTO
>(
  Actions.INSI_CREATE_BATCH_CHECK_REQUEST,
  async (payload, { rejectWithValue }) => {
    try {
      return await InsiService.createBatchCheckRequest(payload)
    } catch (error: any) {
      return handleInsiError(error, rejectWithValue)
    }
  },
)

export const updateInsiBatchCheckRequestResult = createAsyncThunk<
  InsiVerificationBatchRequestDTO,
  { batchId: string; payload: UpdateInsiBatchCheckRequestResultDTO }
>(
  Actions.INSI_UPDATE_BATCH_CHECK_REQUEST_RESULT,
  async ({ batchId, payload }, { rejectWithValue }) => {
    try {
      return await InsiService.updateBatchCheckRequestResult(batchId, payload)
    } catch (error: any) {
      return handleInsiError(error, rejectWithValue)
    }
  },
)

export const deleteInsiBatchCheckRequest = createAsyncThunk<string, string>(
  Actions.INSI_DELETE_BATCH_CHECK_REQUEST,
  async (batchId, { rejectWithValue }) => {
    try {
      await InsiService.deleteBatchCheckRequest(batchId)
      return batchId
    } catch (error: any) {
      return handleInsiError(error, rejectWithValue)
    }
  },
)

export const findPendingInsiBatchRequests = createAsyncThunk<
  InsiVerificationBatchRequestDTO[]
>(Actions.INSI_FIND_PENDING_BATCH_REQUESTS, async (_, { rejectWithValue }) => {
  try {
    return await InsiService.findPendingVerificationBatchRequests()
  } catch (error: any) {
    return handleInsiError(error, rejectWithValue)
  }
})

export const getInsiBatchResult = createAsyncThunk<
  { batchId: string; result: InsiBatchResultResponseDTO },
  { batchId: string; request: InsiBatchResultRequest }
>(
  Actions.INSI_GET_BATCH_RESULT,
  async ({ batchId, request }, { rejectWithValue }) => {
    try {
      const result = await InsiService.getBatchResult(request)
      return { batchId, result }
    } catch (error: any) {
      return handleInsiError(error, rejectWithValue)
    }
  },
)
